/** Amplify SDK error `.name` values — dictated by AWS, not us. */
export enum IdpErrorName {
  UserNotConfirmed         = 'UserNotConfirmedException',
  NotAuthorized            = 'NotAuthorizedException',
  UserNotFound             = 'UserNotFoundException',
  PasswordResetRequired    = 'PasswordResetRequiredException',
  UsernameExists           = 'UsernameExistsException',
  InvalidPassword          = 'InvalidPasswordException',
  InvalidParameter         = 'InvalidParameterException',
  CodeMismatch             = 'CodeMismatchException',
  ExpiredCode              = 'ExpiredCodeException',
  LimitExceeded            = 'LimitExceededException',
  TooManyRequests          = 'TooManyRequestsException',
  UserAlreadyAuthenticated = 'UserAlreadyAuthenticatedException',
}
